module.exports = __webpack_public_path__ + "static/Bild4-dc1defe0a7c5e9b7d2d9216d35e8a97d.png";